// @flow
import * as React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import styled, { withTheme } from 'styled-components';
import { Redirect, NavLink } from 'react-router-dom';
import LoadingSpinner from 'common/components/LoadingSpinner';
import Helmet from 'react-helmet';
import { translate } from 'react-i18next';

import { openSnackbar } from 'common/modules/ui/actions/uiActions';

import ForgotPasswordForm from './ForgotPasswordForm';
import { AuthWrapper, LoginCard, Logo, LoginSection, ButtonSubmit } from '../styles';

export const REDIRECT_ID = 'forgot-password-redirection';
export const FORM_ID = 'forgot-password-form';
export const LOADING_ID = 'forgot-password-loading';
export const SUCCESS_MESSAGE_ID = 'forgot-password-success-message';
export const RETURN_ID = 'forgot-password-return-button';

const Message = styled.div`
  margin: ${({ theme }) => `${theme.metrics.largeMargin}px 0`};
  overlow-wrap: break-word;
  word-wrap: break-word;
`;

type Props = {
  isAuthenticated: boolean,
  onResetPassword: (email: string) => void,

  actions: {
    openSnackbar: (type: 'error', message: string) => void,
  },

  theme: Object,
  t: any,
}

type State = {
  isRequesting: boolean;
  hasSentRequest: boolean;
}

export class ForgotPasswordPage extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {
      isRequesting: false,
      hasSentRequest: false,
    };
  }

  async resetPassword(email: string) {
    const { actions, t } = this.props;
    this.setState({ isRequesting: true });

    try {
      await this.props.onResetPassword(email);
      this.setState({ isRequesting: false, hasSentRequest: true });
    } catch (error) {
      this.setState({ isRequesting: false });
      actions.openSnackbar('error', t('forgotPasswordError'));
    }
  }

  render() {
    const { isAuthenticated, t } = this.props;
    const { hasSentRequest, isRequesting } = this.state;
    const { images } = this.props.theme;

    if (isAuthenticated) {
      return <Redirect id={REDIRECT_ID} to="/" />;
    }

    const displayLoading = isRequesting;
    const displayForm = !isRequesting && !hasSentRequest;
    const displayRequestSent = !isRequesting && hasSentRequest;

    return (
      <AuthWrapper>
        <Helmet>
          <title>{t('forgotPassword')}</title>
        </Helmet>
        <LoginCard zDepth={5}>
          <LoginSection>
            <Logo
              src={images.logo}
              alt="logo"
            />
            {displayForm &&
              <ForgotPasswordForm id={FORM_ID} onSubmit={data => this.resetPassword(data.email)} />
            }
            {displayLoading &&
              <LoadingSpinner id={LOADING_ID} size="large" style={{ marginTop: '3%' }} />
            }
            {displayRequestSent &&
              <React.Fragment>
                <Message id={SUCCESS_MESSAGE_ID}>{t('forgotPasswordSent')}</Message>
                <NavLink id={RETURN_ID} to="/">
                  <ButtonSubmit>{t('forgotPasswordReturn')}</ButtonSubmit>
                </NavLink>
              </React.Fragment>
            }
          </LoginSection>
        </LoginCard>
      </AuthWrapper>
    );
  }
}

function mapStateToProps(state) {
  return {};
}

function mapDispatchToProps(dispatch: *) {
  return {
    actions: bindActionCreators({ openSnackbar }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(withTheme(translate('commonAuthentication')(ForgotPasswordPage)));



// WEBPACK FOOTER //
// ./src/common/modules/authentication/resetPassword/ForgotPasswordPage.js